<section class="pt-2 ">
  <div class="">
    <div class="row align-items-center border mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle de lista de precio' : 'Detalle de lista de precio' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton" [width]="'7rem'"
          (onClick)="openArticleSelectionModal()"></app-custom-button>
        <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Artículos fuera de la lista'"
          [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-price-list-detail [priceListModel]="priceListModel"
          [priceListDetailContract]="priceListDetailModel" [permissionUpdatable]="permissionUpdatable"
          (isFormView)="getFormView($event)" (updateListDetail)="getPriceListDetails()">
        </app-register-price-list-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions" [showRecover]="true"
        [showCheckbox]=" !this.disabledButton " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" [previousFilters]="filters" [showExport]="true"
        [showImport]="true" (onRecoverData)="getPriceListDetails()" (onImport)="onImport()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>

<app-custom-modal #priceListDetailImportModal [label]="'Importar'" [width]="'50rem'"
  [header]="'Importar Detalle Lista de Precios'" [children]="componentPriceListDetailImportModal"
  [inputs$]="inputsForImportModal$" (params)="reloadList($event.reload)" hidden></app-custom-modal>